export default __webpack_public_path__ + "static/media/icon_finishingtype_Bright.7192ff25.png";